import { render, staticRenderFns } from "./LoaderPop.vue?vue&type=template&id=2304f684"
import script from "./LoaderPop.vue?vue&type=script&lang=js"
export * from "./LoaderPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports